module.exports = __webpack_public_path__ + "img/Invasion-CECA_10X_CC.41efd582.png";